import React from "react";
import { observer } from "mobx-react-lite";
import { NewTransactionalPassword } from "../../../components/templates";
import { useState } from "react";
import { useGlobalStore } from "../../../contexts/globalStoreContext";
import { HasPassword } from "../../../enum/password";
import { useAnalytics, useNavigateCustom } from "../../../hooks";
import { strings } from "../../../localization";

const { errorOfLength } = strings.organisms.inputsNewPassword;

const PasswordRegistration: React.FC = observer(() => {
	const { passwordStore, fintechRegisterStore } = useGlobalStore();
	const { updatePageView, addAnalyticEvent } = useAnalytics();

	const navigation = useNavigateCustom();
	const [password, setPassword] = useState("");

	const onConfirm = async (): Promise<void> => {
		const { buttonPrimary } = strings.components.buttons;
		addAnalyticEvent(
			{
				component: "button",
				action: "click.button",
				step: "fgts:cadastro:criar-senha",
				description: buttonPrimary,
				event: "interaction",
			},
			{ applySanitize: true },
		);

		const { success } = await passwordStore.sendTransactionPassword(password);
		if (success) {
			fintechRegisterStore.setStatusRegisteredPassword(HasPassword.ACTIVE);
			fintechRegisterStore.clearState();
			navigation("/fintech-registration/register-success", { state: { isCreated: true }, replace: true });
		}
	};

	const handleChckboxValueAnalyticEvent = (description: string): void => {
		addAnalyticEvent(
			{
				component: "checkbox",
				action: "click.checkbox",
				step: "fgts:cadastro:criar-senha:confirmar-termos",
				description,
				event: "interaction",
			},
			{ applySanitize: true },
		);
	};

	const handleCheckboxLinkAnalyticEvent = (description: string): void => {
		addAnalyticEvent(
			{
				component: "button",
				action: "click.button",
				step: "fgts:cadastro:criar-senha:termos",
				description,
				event: "interaction",
			},
			{ applySanitize: true },
		);
	};

	const handleErrorFormEvent = (errorText: string): void => {
		addAnalyticEvent(
			{
				component: "body",
				action: "view-error",
				step: "fgts:cadastro:criar-senha",
				description: errorText,
				event: "non_interaction",
			},
			{ applySanitize: true },
		);
	};

	React.useEffect(() => {
		updatePageView({
			name: "Vivo Money Cadastro FGTS Senha Numerica",
			pagePath: "/cadastro-fgts/cadastrar-senha",
		});
		handleErrorFormEvent(errorOfLength);
		setTimeout(() => {
			window.scrollTo(0, 0);
		}, 0);
	}, []);

	return (
		<NewTransactionalPassword
			pathLinkTerms="/fintech-registration/terms-of-conditions"
			onActionButton={onConfirm}
			onValueInput={(value) => setPassword(value)}
			handleChckboxValueAnalyticEvent={handleChckboxValueAnalyticEvent}
			handleCheckboxLinkAnalyticEvent={handleCheckboxLinkAnalyticEvent}
			handleErrorFormEvent={handleErrorFormEvent}
		/>
	);
});

export default PasswordRegistration;
